import React, { useState } from "react";
import { DatePicker, Empty, Form, Spin, Table } from "antd";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import { DownloadOutlined } from "@ant-design/icons";
import { generateTurnoverPDF } from "./TurnoverStatementReport";
import { useNavigate } from "react-router-dom";

export default function TurnoverStatement() {
  let customerId = localStorage.getItem("userId");
  let userName = localStorage.getItem("userName");
  const [loading, setLoading] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [turnoverData, setTurnoverData] = useState(null);
  const [dateForm] = Form.useForm();
  const navigate = useNavigate();

  const getTurnoverStatement = async (values) => {
    try {
      setLoading(true);
      let formattedFormDate = values.fromDate.format("DD-MMM-YY");
      let formattedToDate = values.toDate.format("DD-MMM-YY");
      const res = await getRequest(
        urls.turnOverStatement(customerId, formattedFormDate, formattedToDate),
      );
      setTurnoverData(res);
      setShowDownload(true);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const turnOverColumns = [
    { title: "Product", dataIndex: "PACKET_NAME" },
    {
      title: "Rate",
      dataIndex: "RATE",
      width: 60,
      align: "center",
    },
    {
      title: "Qty",
      dataIndex: "QTY_PKTS",
      width: 60,
      align: "center",
    },
    {
      title: "Amount",
      dataIndex: "AMOUNT",
      width: 75,
      align: "center",
    },
  ];

  return (
    <div>
      <div className="page-header">
        Turnover Statement{" "}
        {showDownload &&
          turnoverData &&
          turnoverData.length > 0 &&
          !loading && (
            <DownloadOutlined
              style={{
                fontSize: 26,
                cursor: "pointer",
                color: "#1890ff",
                marginRight: 15,
              }}
              onClick={() => {
                const fromDate = dateForm
                  .getFieldValue("fromDate")
                  .format("DD/MM/YY");
                const toDate = dateForm
                  .getFieldValue("toDate")
                  .format("DD/MM/YY");
                generateTurnoverPDF(turnoverData, fromDate, toDate, {
                  userName,
                });
              }}
              title="Download Turnover PDF"
            />
          )}
      </div>

      <Form
        className="date-range-form"
        form={dateForm}
        layout={"horizontal"}
        onFinish={getTurnoverStatement}
        requiredMark={false}
        onValuesChange={() => setShowDownload(false)}
        style={{
          marginTop: 10,
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Form.Item
          noStyle
          name={"fromDate"}
          rules={[{ required: true, message: "Please select from date" }]}
        >
          <DatePicker
            style={{ width: 250 }}
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
          />
        </Form.Item>
        <span style={{ margin: "0 4px" }}>To</span>
        <Form.Item
          noStyle
          name={"toDate"}
          rules={[{ required: true, message: "Please select to date" }]}
        >
          <DatePicker
            style={{ width: 250 }}
            suffixIcon={<CalendarIcon />}
            format="DD/MM/YY"
          />
        </Form.Item>
        <Form.Item noStyle>
          <button
            style={{
              width: 60,
              padding: 7,
              backgroundColor: "#1890ff",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              marginLeft: 8,
              boxShadow: "none",
            }}
            onClick={() => dateForm.submit()}
          >
            Go
          </button>
        </Form.Item>
      </Form>
      {!loading && turnoverData ? (
        <>
          <Table
            dataSource={loading ? [] : turnoverData}
            locale={{
              emptyText: loading ? <Spin /> : <Empty />,
            }}
            columns={turnOverColumns}
            bordered
            scroll={{ y: "calc(100vh - 420px)", x: 200 }}
            pagination={false}
          />
        </>
      ) : null}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : null}
    </div>
  );
}
